import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';

import { AngularFireModule } from 'angularfire2';
import { AngularFireDatabaseModule } from 'angularfire2/database';
import { AngularFireAuthModule } from 'angularfire2/auth';
import { environment } from '../environments/environment';

import { AgmCoreModule } from '@agm/core';
import { AgmDirectionModule } from 'agm-direction';
import { TimeAgoPipe } from 'time-ago-pipe';
import { CookieModule } from 'ngx-cookie';

import { FirebaseService } from './services/firebase.service';
import { LoginService } from './services/login.service';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';

library.add(fas, far);

import { AppComponent } from './app.component';
import { ChatPanelComponent } from './components/chat-panel/chat-panel.component';
import { MapComponent } from './components/map/map.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { ModalLoginComponent } from './components/modal-login/modal-login.component';

@NgModule({
  declarations: [
    AppComponent,
    ChatPanelComponent,
    MapComponent,
    NavbarComponent,
    ModalLoginComponent,
    TimeAgoPipe,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyBTXraiDSLBaDOSoKTzd1ZL_B3vEORHIHc',
    }),
    AgmDirectionModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireDatabaseModule,
    FontAwesomeModule,
    CookieModule.forRoot(),
  ],
  providers: [
    FirebaseService,
    LoginService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
